<template>
  <div class="input-box">
    <div>
      <label>
        <p>日付：</p>
        <input type="text"
        placeholder="12月20日(土)、1日目"
        v-model="inputEventDate" required>
      </label>
    </div>
    <div class="input-box-btns">
      <button @click="cancel">キャンセル</button>
      <template v-if="editModeD">
        <button @click="editEventDate">編集</button>
      </template>
      <template v-else>
        <button @click="newEventDate">決定</button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputEventDate: "",
    }
  },
  computed: {
    dateObjects: {
      get() {
        return this.$store.getters.dateObjects;
      },
    },
    editModeD: {
      get() {
        return this.$store.getters.editModeD;
      },
    },
    editIndexD: {
      get() {
        return this.$store.getters.editIndexD;
      },
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    newEventDate() {
      if(this.inputEventDate === "") {
        alert("入力されていない項目があります");
        return;
      }
      this.$emit('new-date', this.inputEventDate);
      this.inputEventDate = "";
    },
    editEventDate() {
      if(this.inputEventDate === "") {
        alert("入力されていない項目があります");
        return;
      }
      this.$emit('edit-date', this.inputEventDate);
      this.inputEventDate = "";
    }
  },
  watch: {
    editModeD: function() {
      const vm = this;
      if (vm.editModeD === true) {
        vm.inputEventDate = vm.dateObjects[vm.editIndexD].date;
      } else {
        vm.inputEventDate = "";
      }
    }
  }
}
</script>

<style>

</style>